module.exports = __webpack_public_path__ + "img/interest-3.ce847cbc.png";